import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TextField } from '@material-ui/core';

import { integer } from 'components/FieldTypes/formatters';
import { ReturnRow } from 'types/ReturnTable';
import { setOneOrderSelected } from 'actions/returnProducts';

type Props = {
  row: ReturnRow;
};

const RowAmount: React.FC<Props> = ({ row }) => {
  const { t } = useTranslation('return', { keyPrefix: 'errors' });

  const dispatch = useDispatch();
  const amountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      setOneOrderSelected(row.stableRowID, {
        ...row,
        amount: integer(e.target.value, String(row.amount ?? 0)),
      }),
    );
  };

  const isSelected = !!row?.selected;

  const errorText = (() => {
    if (Number(row.amount) === 0) {
      return t('minAmount', { amount: Math.min(1, row.remainingAmount) });
    }
    if (Number(row.amount) > Number(row.remainingAmount)) {
      return t('maxAmount');
    }
    return '';
  })();

  if (!isSelected) return null;

  return (
    <TextField
      onChange={amountChange}
      data-testid="product-row-qty"
      variant="outlined"
      size="small"
      fullWidth
      helperText={errorText.length > 0 ? errorText : ''}
      error={errorText.length > 0}
      value={String(row.amount ?? 0)}
    />
  );
};

export default RowAmount;
